import { FormHelperText } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import Select from "react-select";
import { Card, CardBody, CardHeader } from "../../_metronic/_partials/controls";
import { getAnswers } from "../../api/answer";
import { getRegattas } from "../../api/regatta";
import { getBoatsByRegatta } from "../../api/boat";
import { getQuizzes } from "../../api/quiz";
import { getScenes } from "../../api/scene";
import { alertError } from "../../utils/logger";
import {
	QuizResultsTable,
	ResultsTable,
	resultFormatter,
} from "../components/tables/table";

function getRegattaQuizzesData(boats, scenarios, quizzes, answers) {
	let data = [];
	scenarios.forEach((scenario) => {
		let quizzesRes = [];
		quizzes
			.filter(
				(quiz) => quiz.scenario._id === scenario._id && !quiz.supertest
			)
			.forEach((quiz) => {
				let quizRes = {};
				boats.forEach((boat, indexBoat) => {
					let answer = answers.find(
						(answer) =>
							answer.quiz === quiz._id &&
							answer.boat === boat._id
					);
					if (answer) {
						quizRes[`boat${indexBoat + 1}`] = {
							pts: answer.score,
							time: answer.time,
							name: boat.fullName,
						};
						quizRes[`boat${indexBoat + 1}`].correct =
							answer.score === 1;
					}
				});
				quizRes.quiz = quiz.fullName;
				quizzesRes.push(quizRes);
			});
		let elem = { scenario: scenario.fullName, results: quizzesRes };
		data.push(elem);
	});
	return data;
}

function getRegattaData(boats, scenarios, answers) {
	let data = [];

	scenarios.forEach((scenario, indexScenario) => {
		let elem = {};
		elem.scenario = `Scenario ${indexScenario + 1}`;
		elem.scenarioName = scenario.fullName;
		boats.forEach((boat, indexBoat) => {
			let boatAnswers = answers.filter((answer) => {
				return (
					answer.scenario === scenario._id &&
					answer.boat === boat._id
				);
			});
			let result = null;
			if (boatAnswers.length)
				result = boatAnswers?.reduce((a, b) => ({
					score: a.score + b.score,
					time: a.time + b.time,
				}));
			if (result)
				elem[`boat${indexBoat + 1}`] = {
					pts: result.score,
					time: result.time,
					name: boat.fullName,
				};
		});
		data = data.concat(elem);
	});
	return data;
}

export function ResultsPage() {
	const [regattas, setRegattas] = useState([]);
	const [boats, setBoats] = useState([]);
	const [quizzes, setQuizzes] = useState([]);
	const [answers, setAnswers] = useState([]);
	const [scenarios, setScenarios] = useState([]);
	const [quizzesData, setQuizzesData] = useState([]);
	const [actualRegatta, setActualRegatta] = useState({ fullName: "" });
	const [data, setData] = useState([]);
	const [isExpanded, setIsExpanded] = useState(false);
	const [expandedRows, setExpandedRows] = useState([]);
	const [refresh, setRefresh] = useState(false);
	const user = useSelector(
		(store) => store.authentication?.user,
		shallowEqual
	);

	function styleFormatter(cell, row) {
		if (cell) {
			let max = true;
			let min = true;
			for (let i = 1; i < 10; ++i) {
				if (
					row[`boat${i}`]?.pts > cell.pts ||
					(row[`boat${i}`]?.pts === cell.pts &&
						row[`boat${i}`]?.time < cell.time)
				) {
					max = false;
				}

				if (
					row[`boat${i}`]?.pts < cell.pts ||
					(row[`boat${i}`]?.pts === cell.pts &&
						row[`boat${i}`]?.time > cell.time)
				) {
					min = false;
				}
				if (!min && !max) {
					return;
				}
			}
			if (max) return { backgroundColor: "#c8e6c9" };
			else if (min) return { backgroundColor: "#e6c8c8" };
		}
	}

	function boatFormatter(column, colIndex) {
		return <div>{boats[colIndex - 1]?.fullName || column.text}</div>;
	}

	const handleOnExpandRow = (row, isExpand, rowIndex, e) => {
		if (isExpand) {
			setExpandedRows([...expandedRows, row.scenario]);
		} else {
			setExpandedRows(expandedRows.filter((x) => x !== row.scenario));
		}
	};

	const expandRow = {
		renderer: (row) => (
			<div style={{ margin: "10px" }}>
				<b>{`${row.scenarioName} | Quizzes Results`}</b>
				<QuizResultsTable
					data={
						quizzesData[row.scenario.match(/\d+/)[0] - 1]?.results
					}
					columns={quizColumns}
				/>
			</div>
		),
		showExpandColumn: true,
		onlyOneExpanding: true,
		expanded: expandedRows,
		onExpand: handleOnExpandRow,
		expandHeaderColumnRenderer: ({ isAnyExpands }) => {
			if (isAnyExpands) {
				return <b>-</b>;
			}
			return <b>+</b>;
		},
		expandColumnRenderer: ({ expanded }) => {
			if (expanded) {
				return <b>-</b>;
			}
			return <b>...</b>;
		},
	};

	const header = (
		<div
			style={{
				display: "flex",
				flexDirection: "row",
			}}
		>
			<h4
				style={{
					textAlign: "center",
					color: "rgb(24, 28, 50)",
					border: "1px solid rgb(215, 218, 231)",
					borderWidth: "0px 0px 2px 0px",
					padding: "0.5em",
				}}
			>
				{"Results"}
			</h4>
		</div>
	);

	const columns = [
		{ dataField: "scenarioName", text: "Scenario" },
		{
			dataField: "boat1",
			text: "Boat 1",
			headerAlign: "center",
			headerFormatter: boatFormatter,
			formatter: resultFormatter,
			style: styleFormatter,
		},
		{
			dataField: "boat2",
			text: "Boat 2",
			headerAlign: "center",
			headerFormatter: boatFormatter,
			formatter: resultFormatter,
			style: styleFormatter,
		},
		{
			dataField: "boat3",
			text: "Boat 3",
			headerAlign: "center",
			headerFormatter: boatFormatter,
			formatter: resultFormatter,
			style: styleFormatter,
		},
		{
			dataField: "boat4",
			text: "Boat 4",
			headerAlign: "center",
			headerFormatter: boatFormatter,
			formatter: resultFormatter,
			style: styleFormatter,
		},
		{
			dataField: "boat5",
			text: "Boat 5",
			headerAlign: "center",
			headerFormatter: boatFormatter,
			formatter: resultFormatter,
			style: styleFormatter,
		},
		{
			dataField: "boat6",
			text: "Boat 6",
			headerAlign: "center",
			headerFormatter: boatFormatter,
			formatter: resultFormatter,
			style: styleFormatter,
		},
		{
			dataField: "boat7",
			text: "Boat 7",
			headerAlign: "center",
			headerFormatter: boatFormatter,
			formatter: resultFormatter,
			style: styleFormatter,
		},
		{
			dataField: "boat8",
			text: "Boat 8",
			headerAlign: "center",
			headerFormatter: boatFormatter,
			formatter: resultFormatter,
			style: styleFormatter,
		},
		{
			dataField: "boat9",
			text: "Boat 9",
			headerAlign: "center",
			headerFormatter: boatFormatter,
			formatter: resultFormatter,
			style: styleFormatter,
		},
		{
			dataField: "boat10",
			text: "Boat 10",
			headerAlign: "center",
			headerFormatter: boatFormatter,
			formatter: resultFormatter,
			style: styleFormatter,
		},
	];
	const quizColumns = [
		{ dataField: "quiz", text: "Quiz", headerAlign: "center" },
		{
			dataField: "boat1",
			text: "Boat 1",
			headerAlign: "center",
			headerFormatter: boatFormatter,
			formatter: resultFormatter,
		},
		{
			dataField: "boat2",
			text: "Boat 2",
			headerAlign: "center",
			headerFormatter: boatFormatter,
			formatter: resultFormatter,
		},
		{
			dataField: "boat3",
			text: "Boat 3",
			headerAlign: "center",
			headerFormatter: boatFormatter,
			formatter: resultFormatter,
		},
		{
			dataField: "boat4",
			text: "Boat 4",
			headerAlign: "center",
			headerFormatter: boatFormatter,
			formatter: resultFormatter,
		},
		{
			dataField: "boat5",
			text: "Boat 5",
			headerAlign: "center",
			headerFormatter: boatFormatter,
			formatter: resultFormatter,
		},
		{
			dataField: "boat6",
			text: "Boat 6",
			headerAlign: "center",
			headerFormatter: boatFormatter,
			formatter: resultFormatter,
		},
		{
			dataField: "boat7",
			text: "Boat 7",
			headerAlign: "center",
			headerFormatter: boatFormatter,
			formatter: resultFormatter,
		},
		{
			dataField: "boat8",
			text: "Boat 8",
			headerAlign: "center",
			headerFormatter: boatFormatter,
			formatter: resultFormatter,
		},
		{
			dataField: "boat9",
			text: "Boat 9",
			headerAlign: "center",
			headerFormatter: boatFormatter,
			formatter: resultFormatter,
		},
		{
			dataField: "boat10",
			text: "Boat 10",
			headerAlign: "center",
			headerFormatter: boatFormatter,
			formatter: resultFormatter,
		},
	];

	useEffect(() => {
		getRegattas().then((res) => {
			if (res.status === 200) {
				let regattas = res.data;
				setRegattas(res.data);

				if (user?.regatta) {
					let regatta = regattas.find((x) => x._id === user?.regatta);
					if (regatta) {
						setActualRegatta(regatta);
					}
				}
			}
		});
	}, []);

	useEffect(() => {
		if (actualRegatta?._id) {
			getBoatsByRegatta(actualRegatta._id)
				.then((resBoats) => {
					if (resBoats.status === 200) {
						let boats = resBoats.data;
						setBoats(boats);
						setQuizzesData(
							getRegattaQuizzesData(
								boats,
								scenarios,
								quizzes,
								answers
							)
						);
						setData(getRegattaData(boats, scenarios, answers));
						setRefresh(false);
					}
				})
				.catch((error) => {
					alertError({
						error: error,
						customMessage: "Could not get regatta boats.",
					});
				});
		}
	}, [actualRegatta]);

	useEffect(() => {
		getQuizzes()
			.then((res) => {
				if (res.status === 200) {
					setQuizzes(res.data);
					getAnswers()
						.then((res) => {
							if (res.status === 200) {
								setAnswers(res.data);
								getScenes()
									.then((res) => {
										if (res.status === 200) {
											setScenarios(res.data);
											getRegattas()
												.then((res) => {
													if (res.status === 200) {
														setRegattas(res.data);
														if (user?.regatta) {
															setActualRegatta(
																res.data.filter(
																	(elem) => {
																		return (
																			elem._id ===
																			user?.regatta
																		);
																	}
																)[0]
															);
														}
														setRefresh(false);
													}
												})
												.catch((error) => {
													alertError({
														error: error,
														customMessage:
															"Could not get regattas.",
													});
												});
										}
									})
									.catch((error) => {
										alertError({
											error: error,
											customMessage:
												"Could not get scenarios.",
										});
									});
							}
						})
						.catch((error) => {
							alertError({
								error: error,
								customMessage: "Could not get answers.",
							});
						});
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "Could not get quizzes.",
				});
			});
	}, [refresh]);

	return (
		<>
			<Card>
				<CardHeader
					title={`${
						user?.regatta ? actualRegatta?.fullName : "Regatta results"
					}`}
				></CardHeader>
				<CardBody>
					{!user?.regatta && (
						<>
							<Select
								options={regattas?.map((regatta) => ({
									label: regatta.fullName,
									value: regatta._id,
								}))}
								value={regattas
									?.filter(
										(regatta) => regatta._id === actualRegatta._id
									)
									.map((regatta) => ({
										label: regatta.fullName,
										value: regatta._id,
									}))}
								onChange={(value) => {
									setActualRegatta(
										regattas.filter(
											(regatta) => regatta._id === value.value
										)[0]
									);
									setRefresh(true);
								}}
								isClearable
								isSearchable
								placeholder={`Select regatta...`}
								className="mb-3 mt-3"
							/>
							<FormHelperText>Select a Regatta</FormHelperText>
						</>
					)}
					{actualRegatta.fullName && (
						<ResultsTable
							data={data}
							columns={columns}
							header={header}
							expandRow={expandRow}
						/>
					)}
				</CardBody>
			</Card>
		</>
	);
}
